import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StateProfileParams } from "../types/profiles/profileParams";

interface ProfilesInitialStateParams {
    isLoading: boolean;
    getAllProfiles: StateProfileParams[];
    searchProfile: StateProfileParams[];
    currentPage: number;
    numberOfPages: number;
    totalNumber: number;
    singleProfile: StateProfileParams | null;
    updateProfile: StateProfileParams[] | null;
    deleteProfile: StateProfileParams[] | null;
}

const initialState: ProfilesInitialStateParams = {
    isLoading: true,
    getAllProfiles: [],
    searchProfile: [],
    currentPage: 1,
    numberOfPages: 0,
    totalNumber: 0,
    singleProfile: null,
    updateProfile: null,
    deleteProfile: null,
}

const profilesSlice = createSlice({
    name: 'PROFILES',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading     = true;
        },
        endLoading: (state) => {
            state.isLoading     = false;
        },
        setProfiles: (state, action: PayloadAction<{
            data: StateProfileParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.getAllProfiles         = action.payload.data;
            state.currentPage         = action.payload.currentPage;
            state.numberOfPages       = action.payload.numberOfPages;
            state.totalNumber         = action.payload.totalNumber;
        },
        setSingleProfile: (state, action: PayloadAction<StateProfileParams>) => {
            state.singleProfile          = action.payload;
        },
        setProfilesSearch: (state, action: PayloadAction<{
            data: StateProfileParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.searchProfile       = action.payload.data;
            state.currentPage         = action.payload.currentPage;
            state.numberOfPages       = action.payload.numberOfPages;
            state.totalNumber         = action.payload.totalNumber;
        },
        setUpdateProfile: (state, action: PayloadAction<StateProfileParams>) => {
            state.updateProfile       = state.getAllProfiles.map((result) =>
                result._id === action.payload._id ? action.payload : result
            );
        },
        setDeleteProfile: (state, action: PayloadAction<string>) => {
            state.deleteProfile = state.getAllProfiles.filter((result) => result._id !== action.payload);
        }
    }
});

export const { startLoading, endLoading, setProfiles, setSingleProfile, setProfilesSearch, setUpdateProfile, setDeleteProfile } = profilesSlice.actions
export default profilesSlice.reducer

